import { Event, EventType } from "./Event";

import type { IAddClickEvent } from "./types";

export class AddClickEvent extends Event {
  constructor({ itemId, tracking, customEventProperties }: IAddClickEvent) {
    super({
      event_type: EventType.click,
      event_properties: {
        item_id: itemId,
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
